const BASE = ['tags'];

export const TAGS_QUERY_KEYS = {
  getTags: () => [...BASE, 'all'] as const,
};
